import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import backIcon from '../images/back-icon.png';

class BackButton extends Component {

    render() {
        const arrow = "<"
        return (

                <div className="row hideDT">
                    <div className="col homeButton">
                      <Link to={this.props.target}>
                        <img src={backIcon} width="12px"/>&nbsp; {this.props.strings.BACK_BUTTON_TEXT}
                      </Link>
                    </div>
                </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        language: state.language.language,
        strings: state.language.strings,
        // default to homepage (app)
        target: ownProps.target ? ownProps.target : "app"
    }
};

const ConnectedBackButton = connect(
    mapStateToProps,
)(BackButton);
export default ConnectedBackButton;
